import { useEffect, useState } from "react";

import { DOCUMENT_EDITOR_FONT_SIZE_OPTIONS } from "~/shared/documents/document-editor-font-size";
import { NativeSelect, type NativeSelectProps, useRichTextEditorContext } from "~/ui";

import styles from "./table.module.css";

export const DocumentFontSizeControl = (props: Omit<NativeSelectProps, "data">) => {
  const { editor } = useRichTextEditorContext();
  const [currentSize, setCurrentSize] = useState("");

  useEffect(() => {
    if (!editor) {
      return undefined;
    }
    const sync = () => {
      const fontSize = editor.getAttributes("textStyle").fontSize;
      setCurrentSize(typeof fontSize === "string" ? fontSize : "");
    };
    sync();
    editor.on("selectionUpdate", sync);
    editor.on("transaction", sync);
    return () => {
      editor.off("selectionUpdate", sync);
      editor.off("transaction", sync);
    };
  }, [editor]);

  return (
    <NativeSelect
      aria-label="Font size"
      disabled={!editor?.isEditable}
      inputClassName={styles.input}
      {...props}
      value={currentSize}
      onChange={event => {
        const next = event.currentTarget.value;
        if (next.length === 0) {
          editor?.chain().focus().unsetDocumentFontSize().run();
          return;
        }
        editor?.chain().focus().setDocumentFontSize(next).run();
      }}
      data={DOCUMENT_EDITOR_FONT_SIZE_OPTIONS.map(option => ({ value: option.value, label: option.label }))}
      placeholder="Font size"
    />
  );
};
